import { GridColDef } from "@mui/x-data-grid";
import CityDetailButton from "./DetailButton";

export const cityColumns: GridColDef[] = [
    {
        field: '',
        renderCell: CityDetailButton,
        width: 150, 
        headerName: '',
        sortable:false,
        filterable:false,
    },
    {
        field: 'cityCode',
        minWidth: 150, 
        headerName: 'Kod',
        sortable:false,
        filterable:false
    },
    {
        field: 'cityName',
        headerName: 'İl',
        flex: 1,
        minWidth: 80,
    },
];